import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

import { useLocale } from "context/locale"

import RoundedWrapper from "components/RoundedWrapper"

import { fadeAnimation } from "utils"

const SingleContent = ({ data }) => {
  const { t } = useLocale()

  return (
    <section className="single-career-content">
      <RoundedWrapper className="single-career-content__wrapper">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <motion.h2 {...fadeAnimation}>{data?.title}</motion.h2>

            <div className="row">
              <motion.div className="col-md-6" {...fadeAnimation}>
                <h4>{t("Office location")}</h4>
                {data?.acfCareer?.officeLocation}
              </motion.div>
              <motion.div className="col-md-6" {...fadeAnimation}>
                <h4>{t("Available remote work")}</h4>
                {data?.acfCareer?.availableRemoteWork}
              </motion.div>
            </div>

            <motion.div {...fadeAnimation}>
              <h4>{t("Minimum requirements")}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.acfCareer?.minimumRequirements,
                }}
              />
            </motion.div>

            <motion.div {...fadeAnimation}>
              <h4>{t("Responsibilities")}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.acfCareer?.responsibilities,
                }}
              />
            </motion.div>

            <motion.div {...fadeAnimation}>
              <h4>{t("Pay & Benefits")}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.acfCareer?.payBenefits,
                }}
              />
            </motion.div>
          </div>
        </div>
      </RoundedWrapper>
    </section>
  )
}

export default SingleContent
